import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditFacilityForm from '../facilities/EditFacilityForm';
import type { FacilityFormValues } from '../facilities/EditFacilityForm';
import { useOnboarding } from '../../store/onboarding-context';

export default function BusinessInfoStep() {
    const { department, refetch } = useOnboarding();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const initialValues = useMemo<Partial<FacilityFormValues>>(() => {
        if (!department) return {};
        return {
            name: department.name || '',
            region: department.region || '',
            address: department.address
                ? {
                      street: department.address.street || '',
                      number: department.address.number || '',
                      postalCode: department.address.postalCode
                          ? String(department.address.postalCode)
                          : '',
                      city: department.address.city || '',
                      country: department.address.country || '',
                  }
                : undefined,
        };
    }, [department]);

    const handleSaved = async () => {
        await refetch();
        navigate('/wizard/users');
    };

    return (
        <div className="space-y-6">
            <div className='mb-10'>
                <h2 className="text-lg font-semibold text-foreground">
                    {t('onboarding.businessInfo.title')}
                </h2>
                <p className="mt-1 text-sm text-muted-foreground">
                    {t('onboarding.businessInfo.description')}
                </p>
            </div>

            <EditFacilityForm
                mode="edit"
                initialValues={initialValues}
                submitLabel={t('onboarding.businessInfo.submitButton')}
                saveMode="siteAdmin"
                allowSubmitWithoutChanges
                onSaved={handleSaved}
            />
        </div>
    );
}
